<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("listaDeInvitaciones")}}</li>
                    </ol>
                </nav>
            </div>

            <CabeceraInformes
                :idBusiness="idBusiness"
                :listBusinesses="listBusinesses"
                :idTpv="idTpv"
                :listTpv="listTpv"
                :dateto="dateto"
                :datefrom="datefrom"
                id="cabecera"
                :conTodos="true"
            />
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <template v-else-if="respuesta">

                <div class="col-md-8" v-if="!mostrarTicket">
                    <template v-if="list.length>0">
                        <div class="row justify-content-between div-export">

                            <div class="col-md-2 col-xs-12 text-right">
                                <el-dropdown>
                                    <el-button type="primary" size="small">
                                        <i class="fa fa-file"></i>
                                        {{$t("exportarInforme")}} <i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <a :href="urlExportPDF">
                                            <el-dropdown-item class="text-danger">
                                                <strong><i class="fa fa-file-pdf"></i> {{$t("exportarPdf")}}</strong>
                                            </el-dropdown-item>
                                        </a>
                                        <a :href="urlExportExcel">
                                            <el-dropdown-item class="text-success">
                                                <strong><i class="fa fa-file-excel"></i> {{$t("exportarExcel")}}</strong>
                                            </el-dropdown-item>
                                        </a>
                                    </el-dropdown-menu>
                                </el-dropdown>

                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-bordered table-striped text-nowrap">
                                <thead class="thead-dark">
                                <tr>
                                    <th>
                                        <span v-if="ordenarCategoria"
                                                @click="sortedArrayASC(1),ordenarCategoria=0"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{$t("categoria")}}
                                        </span>
                                        <span v-else @click="sortedArrayDESC(1), ordenarCategoria=1"><i
                                                style="color: white" class="fa fa-angle-down"></i> {{$t("categoria")}}
                                        </span>

                                    </th>
                                    <th>

                                        <span v-if="ordenarProducto"
                                            @click="sortedArrayASC(2),ordenarProducto=0"><i
                                                style="color: white" class="fa fa-angle-up"></i> {{$t("producto")}}
                                        </span>
                                        <span v-else @click="sortedArrayDESC(2), ordenarProducto=1"><i
                                                style="color: white" class="fa fa-angle-down"></i> {{$t("producto")}}
                                        </span>

                                    </th>
                                    <th>

                                        <span v-if="ordenarUnidades"
                                            @click="sortedArrayASC(3),ordenarUnidades=0"><i
                                                style="color: white" class="fa fa-angle-up"></i> {{$t("unidades")}}
                                        </span>
                                        <span v-else @click="sortedArrayDESC(3), ordenarUnidades=1"><i
                                                style="color: white" class="fa fa-angle-down"></i> {{$t("unidades")}}
                                        </span>


                                    </th>
                                    <th>

                                        <span v-if="ordenarValor"
                                            @click="sortedArrayASC(4),ordenarValor=0"><i
                                                style="color: white" class="fa fa-angle-up"></i> {{$t("valor")}}
                                        </span>
                                        <span v-else @click="sortedArrayDESC(4), ordenarValor=1"><i
                                                style="color: white" class="fa fa-angle-down"></i> {{$t("valor")}}
                                        </span>

                                    </th>
                                    <th>{{$t("acciones")}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="obj in list">
                                    <td><span v-if="obj.category!==''">{{obj.category}}</span><span
                                            v-else>{{$t("sinCategoria")}}</span></td>
                                    <td>{{obj.name}}</td>
                                    <td align="right">{{obj.cantidad}}</td>
                                    <td align="right">{{obj.valor | currency}}</td>
                                    <td width="5%" align="center">
                                        <i @click="getTickets(obj.name)"
                                        class="fas fa-arrow-circle-right"
                                        style="cursor: pointer"
                                        v-tooltip.top-center="$i18n.t('verTicketsDeEsasInvitaciones')"
                                        ></i>
                                    </td>
                                </tr>
                                </tbody>
                                <tfoot>
                                <tr class="table-success">
                                    <td><strong>{{$t("total")}}</strong></td>
                                    <td></td>
                                    <td class="text-right"><strong>{{getTotalCantidad }}</strong></td>
                                    <td class="text-right"><strong>{{getTotalValor | currency}}</strong></td>
                                    <td></td>
                                </tr>
                                </tfoot>
                            </table>
                        </div>


                    </template>
                    <template v-else>
                        <div class="alert alert-danger" role="alert">
                            No hay invitaciones en el rango de fechas seleccionado
                        </div>
                    </template>

                </div>

                <div class="col-md-4 " v-show="this.list.length > 0 && !mostrarTicket">

                    <div class="card">

                        <div class="chart-container col-md-12 " style="height:40vh;">
                            <canvas id="chart"></canvas>
                        </div>

                    </div>
                </div>

                <div class="col-md-12" v-if="mostrarTicket">
                    <div class="card">
                        <div class="col-md-3">
                            <button @click="volver()" class="btn btn-primary"><i
                                    class="fas fa-arrow-circle-left"></i>
                                {{$t("volverALaLista")}}
                            </button>
                        </div>
                        <div class="col-md-12">
                            <template v-for="ticket in tickets">
                                <ticket :ticket="ticket"></ticket>
                            </template>
                        </div>
                    </div>
                </div>
            </template>

            <modal name="filtradoTPV" :adaptive=true :scrollable=true height="auto" :clickToClose=true>
                <div>
                    <div class="modal-header">
                        <h4 style="margin: 0px">{{$t("filtrarPorTPV")}}</h4>
                    </div>
                    <div class="modal-body">

                        <el-checkbox-group :min="1" v-model="idsTPV" size="medium">
                            <el-checkbox v-for="tpv in listCheckBoxTpv" :label=tpv.id :key="tpv.id" border>
                                {{tpv.nameShow}}
                            </el-checkbox>
                        </el-checkbox-group>

                    </div>
                    <div class="modal-footer">
                        <div align="right" class="col-12">
                            <button class="btn btn-primary" @click="getInvitations()"><i class="fa fa-search"></i>
                                {{$t("filtrarTPV")}}
                            </button>
                        </div>
                    </div>
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import Chart from 'chart.js';
    import {
        DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button,
        Checkbox,
        CheckboxGroup,
        Loading
    } from 'element-ui'
    import swal from 'sweetalert2'
    import moment from 'moment'
    import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
    import bus from '../../../../bus'
    import Ticket from '../../../Widgets/Ticket.vue'
    import { mapState } from 'vuex'

    export default {
        created() {
            this.loading = Loading.service({ text: "Cargando..." });
            this.$store.dispatch("setNameRoute", this.$i18n.t("listaDeInvitaciones"));
            this.getBusiness();

            if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
                this.datefrom = this.$store.getters.dateFrom;
                this.dateto = this.$store.getters.dateTo;
            }

            bus.$on('get-ventas', (item) => {
                this.getVentas();
            });

            bus.$on('get-business', (idBusiness) => {
                this.idBusiness = idBusiness;
                this.idsTPV = [];
                this.idTpv = 0;
                this.getTpv();
            });

            bus.$on('get-tpv', (idTpv) => {
                this.idTpv = idTpv;
                this.changeTPV();
            });

            bus.$on('get-date', (dates) => {
                this.value4 = dates;
                this.getInvitations();
            });

            bus.$on('get-open-modal', (item) => {
                this.openModal();
            });
        },
        components: {
            CabeceraInformes,
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup,
            CabeceraInformes,
            'ticket': Ticket
        },
        data() {
            return {
                loading: false,
                loadingScreen: false,
                datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
                dateto: new Date().toISOString(),
                listBusinesses: [],
                idBusiness: 0,
                value4: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
                list: [],
                $Chart: null,
                objectChart: null,
                contador: 0,
                listTpv: [],
                idTpv: 0,
                dateRangeOptions1: {
                    firstDayOfWeek: 1
                },
                listCheckBoxTpv: [],
                idsTPV: [],
                tickets: [],
                mostrarTicket: false,

                //ORDENAR
                ordenarCategoria: 0,
                ordenarProducto: 0,
                ordenarUnidades: 0,
                ordenarValor: 0,

                respuesta:true,
            }
        },
        computed: {
            
            ...mapState(["permiso"]),

            urlExportPDF() {
                var tpv = "";

                this.idsTPV.forEach(function (d) {
                    tpv += d + ',';
                });

                return this.$store.getters.apiUrl+"/products/exportInvitations/PDF?idBusiness=" + this.idBusiness + "&idTpv=" + tpv + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
            },

            urlExportExcel() {
                var tpv = "";

                this.idsTPV.forEach(function (d) {
                    tpv += d + ',';
                });

                return this.$store.getters.apiUrl+"/products/exportInvitations/Excel?idBusiness=" + this.idBusiness + "&idTpv=" + tpv + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
            },

            getTotalValor() {
                let total = 0;

                this.list.forEach(function (d) {
                    total += d.valor;
                });

                return total;
            },

            getTotalCantidad() {
                let total = 0;

                this.list.forEach(function (d) {
                    total += d.cantidad;
                });

                return total;
            }
        },
        methods: {
            cambioBusiness(idBusinessData, listTpv) {
                if (listTpv) {
                    this.listTpv = listTpv;
                }
                
                this.loading = Loading.service({ text: "Cargando..." });
                this.idBusiness = idBusinessData;
                this.idTpv = -1;
                this.idsTPV = [];
                this.list = [];
                this.cambioTpv(this.idTpv);
            },

            emitirConsulta() {
                this.loading = Loading.service({ text: "Cargando..." });
                this.getInvitations();
            },

            cambioTpv(idTpvData, filtrar) {
                if (idTpvData != undefined) {
                    this.idTpv = idTpvData;
                    this.mostrarTicket = false;
                    this.changeTPV();
                }
                
                this.idTpv=idTpvData;
                this.emitirConsulta();
            },

            cambioHora(dates) {
                this.datefrom = dates[0]
                this.dateto = dates[1]
            },

            sortedArrayASC: function (nameAtributo) {
                switch (nameAtributo) {
                    case 1:
                        this.ordenarCategoria = 1;

                        function compareCategoria(a, b) {
                            if (a.category.toUpperCase() < b.category.toUpperCase())
                                return -1;
                            if (a.category.toUpperCase() > b.category.toUpperCase())
                                return 1;
                            return 0;
                        }

                        return this.list.sort(compareCategoria);

                    case 2:
                        this.ordenarProducto = 1;

                        function compareProducto(a, b) {
                            if (a.name.toUpperCase() < b.name.toUpperCase())
                                return -1;
                            if (a.name.toUpperCase() > b.name.toUpperCase())
                                return 1;
                            return 0;
                        }

                        return this.list.sort(compareProducto);

                    case 3:
                        this.ordenarUnidades = 1;

                        function compareUnidades(a, b) {
                            if (a.cantidad < b.cantidad)
                                return -1;
                            if (a.cantidad > b.cantidad)
                                return 1;
                            return 0;
                        }

                        return this.list.sort(compareUnidades);

                    case 4:
                        this.ordenarValor = 1;

                        function compareValor(a, b) {
                            if (a.valor < b.valor)
                                return -1;
                            if (a.valor > b.valor)
                                return 1;
                            return 0;
                        }

                        return this.list.sort(compareValor);
                }
            },
            sortedArrayDESC: function (nameAtributo) { 
                switch (nameAtributo) {
                    case 1:
                        this.ordenarCategoria = 0;

                        function compareCategoria(a, b) {
                            if (a.category.toUpperCase() > b.category.toUpperCase())
                                return -1;
                            if (a.category.toUpperCase() < b.category.toUpperCase())
                                return 1;
                            return 0;
                        }

                        return this.list.sort(compareCategoria);

                    case 2:
                        this.ordenarProducto = 0;

                        function compareProducto(a, b) {
                            if (a.name.toUpperCase() > b.name.toUpperCase())
                                return -1;
                            if (a.name.toUpperCase() < b.name.toUpperCase())
                                return 1;
                            return 0;
                        }

                        return this.list.sort(compareProducto);

                    case 3:
                        this.ordenarUnidades = 0;

                        function compareUnidades(a, b) {
                            if (a.cantidad > b.cantidad)
                                return -1;
                            if (a.cantidad < b.cantidad)
                                return 1;
                            return 0;
                        }

                        return this.list.sort(compareUnidades);

                    case 4:
                        this.ordenarValor = 0;

                        function compareValor(a, b) {
                            if (a.valor > b.valor)
                                return -1;
                            if (a.valor < b.valor)
                                return 1;
                            return 0;
                        }

                        return this.list.sort(compareValor);
                }
            },

            volver() {
                this.mostrarTicket = false;

                this.getInvitations();
            },

            getTickets(name) {
                this.loadingScreen = Loading.service({text: 'Cargando tickets...'});

                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt,
                        idTpv: this.idsTPV,
                        nombre: name ,
                        datefrom: moment(this.datefrom).startOf("day").unix(),
                        dateto: moment(this.dateto).endOf("day").unix(),
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "products/getTicketsInvitationsByBusiness", config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.tickets = response.data.result.tickets;

                            vm.mostrarTicket = true;
                            vm.loadingScreen.close();

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            changeTPV() {
                if (this.idTpv === -1) {
                    this.idsTPV = [];

                    for (let i = 0; i < this.listTpv.length; i++) {
                        this.idsTPV.push(this.listTpv[i].id)
                    }

                } else {
                    this.idsTPV = []
                    this.idsTPV.push(this.idTpv)
                }

                this.getInvitations();
            },

            openModal() {
                this.$modal.show('filtradoTPV');
            },

            getTpv() {
                this.mostrarTicket = false;
                this.tickets = [];
                this.listTpv = [];

                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
                    .then(function (response) {
                        if (response.data.response) {

                            for (let i = 0; i < response.data.result.length; i++) {
                                vm.idsTPV.push(response.data.result[i].id)
                            }

                            vm.listCheckBoxTpv = response.data.result;

                            let printer = {
                                nameShow: vm.$t('todos'),
                                id: 0
                            };

                            vm.listTpv.push(printer);

                            for (let i = 0; i < response.data.result.length; i++) {
                                let printername = {
                                    nameShow: response.data.result[i].nameShow,
                                    id: response.data.result[i].id
                                };

                                vm.listTpv.push(printername)
                            }

                            vm.getInvitations();
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            getBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {
                        vm.listBusinesses = response.data.result;

                        if (vm.$store.getters.idBusiness) {
                            vm.idBusiness = vm.$store.getters.idBusiness;

                        } else {
                            vm.idBusiness = response.data.result[0].id;
                        }

                        vm.getTpv();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            getInvitations() {

                this.$modal.hide('filtradoTPV');

                if (this.datefrom === null || this.dateto === null) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                    this.loading.close();
                } else {

                    let secondsDesde = moment(this.datefrom).unix();
                    let secondsHasta = moment(this.dateto).unix();

                    if (secondsHasta < secondsDesde) {
                        swal({
                            title: this.$t('ups'),
                            text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                        this.loading.close();

                    } else {

                        this.$store.dispatch("setDateTo", this.dateto);
                        this.$store.dispatch("setDateFrom", this.datefrom);

                        var config = {
                            params: {
                                idBusiness: this.idBusiness,
                                datefrom: moment(this.datefrom).startOf("day").unix(),
                                dateto: moment(this.dateto).endOf("day").unix(),
                                idTpv: this.idsTPV,
                                jwt: this.$store.getters.jwt
                            },
                            headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                        };

                        let vm = this;
                        this.$store.dispatch("setIdBusiness", this.idBusiness);
                        this.axios.get(this.$store.getters.apiUrl + "products/getInvitationsByBusiness", config)
                            .then(function (response) {
                                if (response.data.response) {

                                    vm.list = response.data.result;
                                    vm.respuesta=true;

                                    vm.initChart()

                                } else if (response.data.response == false && response.data.rangoMayor == true) {
                                    swal({
                                        title: "Lo sentimos",
                                        text: response.data.result,
                                        confirmButtonClass: "btn btn-info btn-fill",
                                        type: "info",
                                    });
                                    vm.respuesta = false;
                                }
                                else {
                                    swal({
                                        title: vm.$t('accesoDenegado'),
                                        text: vm.$t('noTienesPermisoParaVisualizarEsteInforme'),
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        type: 'error'
                                    });
                                    vm.respuesta=false;
                                }
                                vm.loading.close();

                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                }
            },

            initChart() {
                var labels = this.list.map(function (x) {
                    return x.name;
                });

                var data = this.list.map(function (x) {
                    return x.cantidad;
                });

                var randomColor = require('randomcolor');

                var colors = randomColor({luminosity: 'dark', count: labels.length, format: 'rgb'});

                let backgroundColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)";
                });

                let borderColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.3)";
                });

                let hoverBackgroundColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 1)";
                });

                if (this.contador == 0) {

                    if (this.list.length > 0) {
                        this.objectChart = new Chart("chart", {
                            type: 'pie',
                            data: {
                                labels: labels,
                                datasets: [{
                                    data: data,
                                    backgroundColor: backgroundColors,
                                    borderColor: borderColors,
                                    hoverBackgroundColor: hoverBackgroundColors,
                                    borderWidth: 1
                                }]
                            },
                            options: {
                                legend: {
                                    display: false,
                                    position: 'bottom',
                                },
                                responsive: true,
                                maintainAspectRatio: false,

                            }
                        });

                        this.contador++;
                    }
                } else {
                    this.objectChart.destroy();

                    this.objectChart = new Chart("chart", {

                        type: 'pie',
                        data: {
                            labels: labels,
                            datasets: [{
                                data: data,
                                backgroundColor: backgroundColors,
                                borderColor: borderColors,
                                hoverBackgroundColor: hoverBackgroundColors,
                                borderWidth: 1
                            }]
                        },
                        options: {
                            legend: {
                                display: false
                            },
                            responsive: true,
                            maintainAspectRatio: false
                        }
                    });

                }
            },
        }
    }
</script>

<style scoped>
    a li {
        color: #111;
    }

    .card {
        padding: 20px;
    }

    .div-export {
        margin-bottom: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Productos/Invitaciones.vue